export default __webpack_public_path__ + "static/media/CSql.86eba060.jpg";